// Libs
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import qs from 'querystring';

const baseQuery = fetchBaseQuery({
  baseUrl: process.env.emailServiceUrl,
  prepareHeaders: (headers) => {
    headers.set('Content-Type', 'application/json');
    headers.set('Accept', 'application/json');
  },
  validateStatus: (response, result) => {
    result = JSON.parse(result);
    if (
      response.status !== 200 ||
      result.success === 'false' ||
      !result.response
    ) {
      return false;
    }

    try {
      if (result.response.data === '') {
        return true;
      }

      typeof result.response.data === 'string' &&
        JSON.parse(result.response.data);
    } catch {
      return false;
    }

    return true;
  },
  paramsSerializer: (params) => qs.stringify(params),
});

export default createApi({
  baseQuery,
  tagTypes: ['Email', 'Recaptcha'],
  endpoints: () => ({}),
});
